/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Pergi_S1Inputs */

const en_tut_pergi_s1 = /** @type {(inputs: Tut_Pergi_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing to switch on. If you come back online after more than twenty minutes away and something needs your attention, the **Selagi Anda pergi** dialog opens by itself.`)
};

const id_tut_pergi_s1 = /** @type {(inputs: Tut_Pergi_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada yang perlu dinyalakan. Kalau Anda kembali online setelah pergi lebih dari dua puluh menit dan ada yang perlu diketahui, dialog **Selagi Anda pergi** terbuka sendiri.`)
};

/**
* | output |
* | --- |
* | "Nothing to switch on. If you come back online after more than twenty minutes away and something needs your attention, the **Selagi Anda pergi** dialog opens ..." |
*
* @param {Tut_Pergi_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_pergi_s1 = /** @type {((inputs?: Tut_Pergi_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Pergi_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_pergi_s1(inputs)
	return en_tut_pergi_s1(inputs)
});